import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class GoalsService {
  constructor(private http: HttpClientService) {}

  public getIndex({ month, goal_type, user_id = undefined, team_id = undefined }): Observable<any> {
    let options = {
      params: {
        month: month,
        goal_type: goal_type,
        user_id: user_id,
        team_id: team_id,
      },
    };
    return this.http.get("/api/goals", options).pipe(tap((_) => console.log("GoalsService.getIndex: Ok.")));
  }

  public postCreate(goal): Observable<any> {
    const options = {
      goal: goal,
    };
    return this.http.post("/api/goals", options).pipe(tap((_) => console.log("GoalsService.postCreate: Ok.")));
  }
}
